import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationService from '../services/navigation.service';

// ----------------------------------------------------------------------
// Registers this router's navigate() with NavigationService so code outside the React
// tree (the axios interceptor) can redirect the user - e.g. bouncing a suspended user's
// stray request off to /portal/companies on a 403.

export default function NavigationBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    NavigationService.setNavigate(navigate);
  }, [navigate]);

  return null;
}
